import type {Pointer} from '@wix/document-services-types'

const transformSet = (): {pointer: Pointer | null; value: any} =>
    //console.warn('Should not be setting to page pointers')
    ({pointer: null, value: null})

export {transformSet}
